import V2Adapter from './v2';

export default class extends V2Adapter {
  // Overwriting createRecord to reuse the same route
  // as the iPad for creating entires. This is stripping
  // out unpermitted properties and renaming fields.
  createRecord(store, type, snapshot) {
    const data = {};
    const serializer = store.serializerFor(type.modelName);
    const url = this.buildURL(type.modelName, null, snapshot, 'createRecord');

    serializer.serializeIntoHashForCreate(data, type, snapshot, { includeId: true });

    return this.ajax(url, 'POST', { data });
  }

  urlForCreateRecord(...args) {
    return `${super.urlForCreateRecord(...args)}?include=visit-approval,visit-approval.screener-results,visit-approval.screener-reviews`;
  }

  urlForFindRecord(id, modelName, snapshot) {
    let url = `${super.urlForFindRecord(id, modelName, snapshot)}?include=visit-approval,visit-approval.screener-results,visit-approval.screener-reviews`;
    const adapterOptions = snapshot?.adapterOptions;

    if (adapterOptions?.['fields']) {
      const queryParams = [];
      const fields = adapterOptions['fields'];

      for (const field in fields) {
        queryParams.push(`fields[${field}]=${fields[field]}`);
      }

      if (queryParams.length > 0) {
        url += `&${queryParams.join('&')}`;
      }
    }

    return url;
  }
}
